import React from "react";
import { LotteryListPage } from "../../../Components/dashboard";

const MyLotteryPage = () => {
  return <LotteryListPage role="creator" />;
};

export default MyLotteryPage;
